
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { useEffect, useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

const Header = () => {
  const [userName, setUserName] = useState<string | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    const storedName = localStorage.getItem("userName");
    setUserName(storedName);
  }, []);

  // Add this function to refresh the header when user logs out
  const handleStorageChange = () => {
    const storedName = localStorage.getItem("userName");
    setUserName(storedName);
  };

  useEffect(() => {
    // Listen for storage events (localStorage changes)
    window.addEventListener("storage", handleStorageChange);
    
    // Also check whenever the component is focused
    window.addEventListener("focus", handleStorageChange);
    
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("focus", handleStorageChange);
    };
  }, []);

  const MenuLinks = () => (
    <span className="text-whiskey-amber/70 text-sm py-2 block">
      Service has shut down
    </span>
  );

  return (
    <header className="bg-whiskey-dark text-white py-4">
      <div className="container mx-auto max-w-7xl px-4 md:px-8">
        <div className="flex justify-between items-center h-[48px]">
          <div className="flex items-center">
            <Link to="/" className="hover:opacity-90 transition-opacity">
              <div className="flex items-center gap-2">
                <h1 className="font-bold tracking-tight text-xl md:text-2xl lg:text-3xl leading-none flex items-center h-full">
                  <span className="text-whiskey-amber">Whiskey</span> Tracker
                </h1>
                <Badge variant="whiskey-compliant" className="font-medium text-xs self-start">
                  Beta
                </Badge>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          {!isMobile && (
            <div className="flex items-center gap-3">
              <MenuLinks />
            </div>
          )}

          {/* Mobile Hamburger Menu */}
          {isMobile && (
            <div className="flex items-center">
              <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
                <SheetTrigger asChild>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="text-whiskey-amber hover:text-whiskey-amber/80 hover:bg-whiskey-amber/10 h-12 w-12 p-0"
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    <Menu className="h-8 w-8" style={{ width: '32px', height: '32px' }} />
                  </Button>
                </SheetTrigger>
                <SheetContent side="right" className="bg-whiskey-dark border-whiskey-amber/20">
                  <SheetHeader>
                    <SheetTitle className="text-whiskey-amber text-left">
                      <span className="text-whiskey-amber">Whiskey</span> Tracker
                    </SheetTitle>
                  </SheetHeader>
                  <div className="mt-6 space-y-1">
                    <MenuLinks />
                  </div>
                </SheetContent>
              </Sheet>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
